import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes';

import AuthProvider from './utils/authProvider';
import userManager, { loadUserFromStorage } from './services/userService';
import store from './store';
import { useSelector } from 'react-redux';
import AppContext from './helpers/context';
import Config from './config';
import withClearCache from './ClearCache';

import jQuery from 'jquery';
import MaintenancePage from 'components/pages/maintenance';
window.$ = jQuery;

function App() {
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    // Test google maps key
    console.log("GMAPS_KEY", process.env.REACT_APP_GMAPS_KEY);

    // console.log('loadUserFromStorage is called');

    // fetch current user from cookies
    loadUserFromStorage(store);
  }, []);

  console.log('FE Version', Config.sourceVersion);
  console.log('Config', Config);
  console.log('Testing build qa new');

  const contextParams = Config.isProd
    ? {
        UserFrom: user?.profile?.UserFrom,
        UserRole: user?.profile?.UserRole,
        UserId: user?.profile?.UserId,
        name: user?.profile?.name,
        access_token: user?.access_token
      }
    : Config.dummyLoginDetails;

  // console.log('contextParams', contextParams);

  window.context = { ...contextParams };

  const isMaintenance = process.env.REACT_APP_MAINTENANCE === 'true';

  if (isMaintenance) return <MaintenancePage />;

  return (
    <AuthProvider userManager={userManager} store={store}>
      <AppContext {...contextParams}>
        <Router>
          <Routes />
        </Router>
      </AppContext>
    </AuthProvider>
  );
}

const MainApp = withClearCache(App);

export default MainApp;
